import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon2",
  "use": "icon-home-item-icon2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon2\">\n<path id=\"icon-home-item-icon2_资格证书\" d=\"M12.6,15.7c1,0.7,2.4,0.7,3.4,0V18l-1.6-0.8c-0.1,0-0.2,0-0.2,0L12.6,18V15.7L12.6,15.7L12.6,15.7z\n\t M14.8,2c0.5,0,0.8,0.3,0.8,0.8v5.6h-2.4c-1.7,0-3.1,1.4-3.2,3.1v0.1v5.6H3.6c-0.5,0-0.8-0.3-0.8-0.8V2.8C2.8,2.4,3.2,2,3.6,2H14.8\n\tL14.8,2z M14.3,10c1.6,0,2.8,1.3,2.8,2.8s-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8C11.5,11.3,12.7,10,14.3,10L14.3,10L14.3,10z M14.3,11.1\n\tL13.8,12l-1,0.2l0.7,0.8v1l1-0.3l1,0.3v-1l0.7-0.8l-1-0.3L14.3,11.1z M8.9,7.6H5.7C5.5,7.6,5.3,7.7,5.2,8v0.1v0.3\n\tc0,0.2,0.1,0.3,0.3,0.3h0.1h3.2c0.2,0,0.3-0.1,0.3-0.3V8.3V8C9.2,7.8,9.1,7.6,8.9,7.6L8.9,7.6z M11.3,4.4H5.7\n\tc-0.2,0-0.3,0.1-0.5,0.3v0.1v0.3c0,0.2,0.1,0.3,0.3,0.3h0.1h5.6c0.2,0,0.3-0.1,0.3-0.3V5.1V4.9C11.6,4.7,11.5,4.4,11.3,4.4L11.3,4.4\n\tz\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon2.svg
// module id = DLjV
// module chunks = 97